import { z } from 'zod'

const versionSchema = z
    .string()
    .refine((value) => /^\d+(\.\d+){0,2}$/.test(value), {
        message: 'Invalid version format. Must be in the format X.Y or X.Y.Z',
    })

const moduleSchema = z.object({
    module: z.string(),
    version: versionSchema,
    readme: z.string(),
})

export const dataSchema = z.object({
    modules: z.array(moduleSchema),
})
